<template>
  <table class="d-table d-table__tasks">
    <thead>
    <tr>
      <th class="th-sorter"
          :class="{'th-sorter--active': sortKey === 'name'}"
          @click="setSortKey('name')">
        {{ getI18n(title) }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter"
          :class="{'th-sorter--active': sortKey === 'calendar'}"
          @click="setSortKey('calendar')">
        {{ $t('vue2.task_overview.belongs_to') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="is-number th-sorter"
          v-if="!isOnlyShowScheduled"
          @click="setSortKey('hours')"
          :class="{'th-sorter--active': sortKey === 'hours'}">
        {{ $t('vue2.assign_users_hours.assigned') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter is-number"
          v-if="isShowScheduled"
          @click="setSortKey('actual')"
          :class="{'th-sorter--active': sortKey === 'actual'}">
        {{ $t('vue2.assign_users_hours.scheduled') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter is-number"
          @click="setSortKey('diff')"
          :class="{'th-sorter--active': sortKey === 'diff'}"
          v-if="isShowScheduled && !isOnlyShowScheduled">
        {{ $t('vue2.assign_users_hours.diff') }}
        <span class="icon-menu-open"></span>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="tasks.length < 1">
      <td style="width: 90%;">
        <div style="padding: 4px" class="italic">{{ $t('vue2.task_overview.no_tasks_assigned') }}</div>
      </td>
      <td></td>
      <td></td>
      <td v-if="isShowScheduled"></td>
      <td v-if="isShowScheduled"></td>
    </tr>
    <tr v-for="task in sortedTasks" :key="task.id" :data-task-id="task.id">
      <td>
        <div class="task-with-edit">
          <div class="subjects_subject"
               v-if="task.can_schedule === 't'"
               :style="{'background': task.color}">
            {{ task.name }}
          </div>
          <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
        </div>
      </td>
      <td class="td-calendars">
        {{ task.calendar }}
      </td>
      <td class="is-number" v-if="!isOnlyShowScheduled">{{ getTasksHours(task) }}</td>
      <td class="is-number" v-if="isShowScheduled">{{ getTaskActual(task) }}</td>
      <td class="is-number" v-if="isShowScheduled && !isOnlyShowScheduled">{{ task.diff }}</td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td></td>
      <td></td>
      <td class="is-number" v-if="!isOnlyShowScheduled" :class="{'th-sorter--active': sortKey === 'hours'}">{{ sumOfHours }}</td>
      <td class="is-number" v-if="isShowScheduled" :class="{'th-sorter--active': sortKey === 'actual'}">{{
          sumOfActual
        }}
      </td>
      <td class="total-hours is-number" v-if="isShowScheduled && !isOnlyShowScheduled" :class="{'th-sorter--active': sortKey === 'diff'}">
        {{ sumOfDiff }}
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DDropdown from '../common/DDropdown'

export default {
  components: {DDropdown},
  props: {
    userCalendarId: {
      default: 13
    },
    userId: {
      default: 7
    },
    title: {
      type: String,
      default: 'Øvrige opgaver'
    },
    tasks: {
      default: () => []
    },
    assignedHours: {
      default: '0.0'
    },
    isShowScheduled: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      sortKey: 'name',
      sortOrder: 1
    }
  },
  computed: {
    isOnlyShowScheduled () {
      return this.title === 'absence' || this.title === 'substitute_hours'
    },
    sortedTasks () {
      let sortKey = this.sortKey
      let order = this.sortOrder
      let data = this.tasks
      if (sortKey) {
        data = data.sort((a, b) => {
          a = a[sortKey]
          b = b[sortKey]
          if (sortKey !== 'name' && sortKey !== 'calendar') {
            if (order < 0) {
              return a - b
            } else {
              return b - a
            }
          } else {
            a = a.toLowerCase()
            b = b.toLowerCase()
            return (a === b ? 0 : a > b ? 1 : -1) * order
          }
        })
      }
      return data
    },
    sumOfHours () {
      let tasksHours = [0]
      if (this.tasks.length > 0) {
        tasksHours = this.tasks.map(task => {
          return task.hours ? parseFloat(task.hours) : 0
        })
      }
      let sum = tasksHours.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfActual () {
      let tasksActual = [0]
      if (this.tasks.length > 0) {
        tasksActual = this.tasks.map(task => {
          let actual = task.actual ? task.actual : 0
          return parseFloat(actual)
        })
      }
      let sum = tasksActual.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfDiff () {
      let tasksNumbers = [0]
      if (this.tasks.length > 0) {
        tasksNumbers = this.tasks.map(task => {
          return task.diff ? parseFloat(task.diff) : 0
        })
      }
      let sum = tasksNumbers.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    }
  },
  methods: {
    getI18n (title) {
      switch (title) {
        case 'teaching':
          return this.$t('vue2.task_overview.teaching')
        case 'other':
          return this.$t('vue2.task_overview.tasks')
        case 'preparation':
          return this.$t('vue2.task_overview.preparation')
        case 'absence':
          return this.$t('vue2.task_overview.absence')
        case 'club':
          return this.$t('vue2.task_overview.club')
        case 'substitute_hours':
          return this.$t('vue2.task_overview.substitute_hours')
        case 'pool':
          return this.$t('vue2.task_overview.pool')
        case 'unknown':
          return this.$t('vue2.task_overview.unknown')
        case 'with_kids':
          return 'Tid med børn'
        case 'without_kids':
          return 'Tid uden børn'
        default:
          return title
      }
    },
    setSortKey (prop) {
      this.sortKey = prop
      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1
    },
    toFixedIfNecessary (value, dp) {
      // https://stackoverflow.com/questions/32229667/have-max-2-decimal-places/32229831
      return +parseFloat(value).toFixed(dp)
    },
    getTaskActual (task) {
      let actual = task.actual ? task.actual * 1 : 0
      return this.toFixedIfNecessary(actual, 2)
    },
    getTasksHours (task) {
      return task.hours ? this.toFixedIfNecessary(task.hours, 2) : ''
    },
    calcDifference (task) {
      let actual = task.actual ? task.actual * 1 : 0
      let hours = task.hours ? parseFloat(task.hours) : null
      return task.hours ? this.toFixedIfNecessary(hours - actual, 2) : ''
    },
    getSubjectHours (task) {
      let theSubject = task
      let idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(teacher => teacher.user_id === this.userId) : -1
      let num = 0
      if (idx > -1) {
        num = theSubject.teachers[idx].hours
      } else {
        num = theSubject.hours
      }
      return parseFloat(num).toFixed(1)
    },
    setEditTask (task) {
      this.$emit('edit', task)
    },
    setDeleteTask (task) {
      this.$emit('delete', task)
    },
    getShowCalendarIfNotOwn (task) {
      let isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId
      if (isInOwnCalendar) {
        return []
      } else {
        return task.belongs_to_calendars ? task.belongs_to_calendars.map(calId => this.allCalendarsInHash[calId]) : [this.allCalendarsInHash[task.calendar_id]]
      }
    },
    scaleIndicator (diff) {
      let color = 'rgba(62, 207, 142, 0.4)'
      let newDiff = parseFloat(diff)
      let indicatorPercentage = parseFloat(newDiff.toFixed(0))
      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
        indicatorPercentage = '0' + indicatorPercentage
      }
      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
        indicatorPercentage = '0' + (indicatorPercentage * -1)
      }
      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
        indicatorPercentage = indicatorPercentage * -1
      }
      if (newDiff === 0) {
        color = 'transparent'
      }
      if (newDiff < 0) {
        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')'
      }
      if (newDiff < -99) {
        color = 'rgba(250, 86, 90, 1)'
      }
      if (newDiff > 0) {
        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')'
      }
      if (newDiff > 99) {
        color = 'rgba(62, 207, 142, 1)'
      }
      return {'backgroundColor': color}
    }
  },
  beforeMount () {
    this.tasks.forEach((task, i) => this.$set(this.tasks[i], 'diff', this.calcDifference(task)))
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table__tasks {
  border-collapse: collapse;
  background-color: #ffffff;
  width: 100%;
}

.d-table__tasks {
  font-size: 10px;
}

.d-table__tasks thead th:first-child,
.d-table__tasks tbody td:first-child {
  max-width: 400px;
  width: 30%
}

.d-table__tasks thead th:nth-child(2),
.d-table__tasks tbody td:nth-child(2),
.d-table__tasks.d-table > tfoot td:nth-child(2) {
  display: none;
}

@media only screen and (min-width: 500px) {
  .d-table__tasks {
    font-size: 1rem;
  }
}

.d-table__tasks thead th:nth-child(2),
.d-table__tasks tbody td:nth-child(2),
.d-table__tasks.d-table > tfoot td:nth-child(2) {
  display: table-cell;
}
.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 4px 8px;
}

.d-table > tfoot tr td {
  color: #8898aa;
}

.d-table > tfoot tr td.th-sorter--active {
  color: var(--dark-blue);
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 8px;
}

.d-table tbody tr:hover {
  background: #eee !important;
}

.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 5px 5px 5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
}

.subjects_subject.subjects_subject--not-subject {
  box-shadow: none;
  background-color: transparent;
  color: var(--dark-blue) !important;
  border: 1px solid transparent;
}

.subjects_subject.subjects_subject--not-subject:hover {
  /* border: 1px solid var(--border-color); */
  border: none;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.italic {
  font-style: italic;
}

.td-calendars {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80px;
  overflow: hidden;
  font-size: 11px;
}

.d-table tbody td:nth-child(2) {
  width: 40%;
}

.d-table tbody td:nth-child(3),
.d-table tbody td:nth-child(4),
.d-table tbody td:nth-child(5) {
  width: 10%;
}

.th-sorter {
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: transform 0.25s;
}

.th-sorter.th-sorter--active {
  color: var(--dark-blue);
}

.th-sorter:active {
  transform: scale(0.99);
}

@media print {
  .subjects_subject {
    background: transparent !important;
    font-weight: normal !important;
    height: auto !important;
    box-shadow: none;
    color: black !important;
    padding: 0;
    margin: 2px 2px 2px 0px;
  }
  .icon-menu-open {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// UserTasksTable.vue?675a8cdf